import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  Aangifte, BokkzAlgDataService, BokkzIbDataService, IncomeTaxEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {BehaviorSubject, combineLatest, Subject, takeUntil} from "rxjs";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiSearchControlModule} from "@snelstart/ui-search-control";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-opgaaf-wereldinkomen',
  templateUrl: './opgaaf-wereldinkomen.component.html',
  styleUrls: ['./opgaaf-wereldinkomen.component.scss'],
  imports: [
    ReactiveFormsModule,
    SharedUiFormControlsModule,
    SharedUiSearchControlModule,
  ]
})
export class OpgaafWereldinkomenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  @Input() partner= new BehaviorSubject<boolean>(false);
  private destroy$= new Subject<void>();
  public partnerBoolean= {} as boolean;
  public incomeTaxEntity= {} as IncomeTaxEntity;
  public clientId!: string;
  public wereldInkomenFg= {} as FormGroup;

  constructor(private fb: FormBuilder,
              public dataService: BokkzIbDataService,
              private dataAlgService: BokkzAlgDataService) {
    this.wereldInkomenFg = this.fb.group({
      winstUitOndernemingBuitenland: null as unknown as number,
      loonTegenwoordigeDienstbetrekkingBuitenland: null as unknown as number,
      pensioenEnAndereUitkeringenBuitenland: null as unknown as number,
      afkoopsomLijfrenteBuitenland: null as unknown as number,
      vrijgesteldLoonTegenwoordigeArbeidBuitenland: null as unknown as number,
      vrijgesteldLoonVroegereArbeidBuitenland: null as unknown as number,
      inkomstenOverigeWerkzaamhedenBuitenland: null as unknown as number,
      inkomstenTerBeschikkingStellingBuitenland: null as unknown as number,
      ontvangenAlimentatieBuitenland: null as unknown as number,
      ontvangenPeriodiekeUitkeringenBuitenland: null as unknown as number,
      reisAftrekOpenbaarVervoerBuitenland: null as unknown as number,
      overigeInkomstenBuitenland: null as unknown as number,
      uitgavenVoorInkomensvoorzieningBuitenland: null as unknown as number,
      negatieveUitgavenVoorInkomensvoorzieningBuitenland: null as unknown as number,
      saldoEigenWoningBuitenland: null as unknown as number,
      aandeelSaldoEigenWoningBuitenland: null as unknown as number,
      aftrekGeenOfGeringeEigenWoningSchuldBuitenland: null as unknown as number,
      aandeelAftrekGeenOfGeringeEigenWoningSchuldBuitenland: null as unknown as number,
      persoonsGebondenAftrekBuitenland: null as unknown as number,
      negatievePersoonsGebondenAftrekBuitenland: null as unknown as number,
      voordeelAanmerkelijkBelangBuitenland: null as unknown as number,
      grondslagSparenEnBeleggenBuitenland: null as unknown as number,
      voordeelSparenEnBeleggenBuitenland: null as unknown as number,
      eldersBelastInkomenBox1: null as unknown as number,
      eldersBelastInkomenBox2: null as unknown as number,
      verhoudingInkomenNederlandWereld: null as unknown as number,
      gezamenlijkeVerhoudingInkomenNederlandWereld: null as unknown as number,
      geenIbWoonlandGeringInkomen: false,
    })
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.pipe(takeUntil(this.destroy$)).subscribe(() => {
      combineLatest([
        this.dataService.incomeTaxEntity,
        this.partner
      ])
        .pipe(takeUntil(this.destroy$))
        .subscribe(([incomeTaxEntity, partner]) => {
          this.incomeTaxEntity = incomeTaxEntity;
          this.partnerBoolean = partner;
          this.updateForm();
        });
    });
    this.dataAlgService.client.pipe(takeUntil(this.destroy$)).subscribe((client) => {
      this.clientId = client.sstRelationId!;
    })
  }

  ngOnDestroy(): void {
    if (this.incomeTaxEntity?.sstRelationId) {
      this.dataService.postIncomeTaxEntity(
        this.incomeTaxEntity.sstRelationId,
        false,
        this.incomeTaxEntity
      );
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateForm() {
    if (!this.partnerBoolean) {
      this.wereldInkomenFg.reset()
      if (this.incomeTaxEntity.aangifte?.buitenlandseBelastingplicht?.wereldInkomen) {
        this.wereldInkomenFg.patchValue(this.incomeTaxEntity.aangifte?.buitenlandseBelastingplicht?.wereldInkomen, {emitEvent:false});
      }
    } else {
      this.wereldInkomenFg.reset()
      if (this.incomeTaxEntity.aangifte?.partnerAangifte?.buitenlandseBelastingplicht?.wereldInkomen) {
        this.wereldInkomenFg.patchValue(this.incomeTaxEntity.aangifte?.partnerAangifte?.buitenlandseBelastingplicht?.wereldInkomen, {emitEvent:false});
      }
    }
  }

  saveForm(): void {
    this.wereldInkomenFg.updateValueAndValidity();
    if (!this.partnerBoolean) {
      this.incomeTaxEntity.aangifte = {
        ...this.incomeTaxEntity.aangifte,
        buitenlandseBelastingplicht: {
          ...this.incomeTaxEntity.aangifte?.buitenlandseBelastingplicht,
          wereldInkomen: this.wereldInkomenFg.getRawValue(),
        }
      } as Aangifte;
    } else {
      this.incomeTaxEntity.aangifte = {
        ...this.incomeTaxEntity.aangifte,
        partnerAangifte: {
          ...this.incomeTaxEntity.aangifte?.partnerAangifte,
          buitenlandseBelastingplicht: {
            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.buitenlandseBelastingplicht,
            wereldInkomen: this.wereldInkomenFg.getRawValue(),
          },
        },
      } as Aangifte;
    }
    this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
  }
}
